import React from "react";

export default function About() {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
      Whether you are planning for a party or simply wondering what to order during your next night out on the town, knowing the most common and popular cocktails makes ordering and serving a breeze. 
      Cocktails typically contain one or more types of liquor along with several mixers, such as fruit juice, citrus juice, mint, honey, bitters, soda, and/or cream.
      </p>
    </section>
  );
}
